import { API } from '@aws-amplify/api';
import './aws-amplify-config';
import { gaeApp } from '../../components/helpers/Analytics';
import { runInAmbient } from '../../telemetry/tracing';

export default class EqxAPI {
  /**
   *
   * @param {String} path to resources
   * @param {Object} [body] body params
   * @param {number} tryCount count to try on Network Error
   * @returns {Promise<any>}
   */
  static post = (path, body, tryCount = 3) => {
    // Nest Fetch/XHR under ambient journey (handoff/document/send), else session.
    return runInAmbient(() => EqxAPI.postInner(path, body, tryCount));
  };

  static postInner = (path, body, tryCount = 3) => {
    return new Promise((resolve, reject) => {
      gaeApp(
        'EQXAPI',
        'REQUEST_INFO',
        JSON.stringify({
          path,
          payloadSize: new Blob([JSON.stringify(body)]).size
        })
      );
      API.post(process.env.REACT_APP_AWS_API_GATEWAY_NAME, path, {
        headers: {
          'Content-Type': 'application/json',
          ...(window.a1eba061831d4929b2a02deb195b6602 && {
            Authorization: `Bearer ${atob(
              window.a1eba061831d4929b2a02deb195b6602
            )}`
          })
        },
        body: { ...body },
        response: false //wird komplette Response zurückgegeben und nicht nur das Data-Objekt
      }).then(
        response => resolve(response),
        error => {
          if (
            error?.response?.data?.message &&
            error?.response?.data?.message.indexOf(
              'The incoming token has expired'
            ) !== -1
          ) {
            window.tokenRefresh();
            setTimeout(() => {
              resolve(EqxAPI.post(path, body));
            }, 3000);
          } else if (error?.message === 'Network Error' && tryCount !== 0) {
            gaeApp('EQXAPI', 'REPEAT_POST_ON_NETWORK_ERROR', path);

            setTimeout(() => {
              resolve(EqxAPI.post(path, body, tryCount - 1));
            }, 3000);
          } else reject(error);
        }
      );
    });
  };

  static test = async (path, body) => {
    const response = await fetch('http://192.168.178.27:8083/' + path);
    return response.json();
  };
}
